import { useState, useEffect } from 'react'

interface DeviceInfo {
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
  isIOS: boolean
  isAndroid: boolean
  isSafari: boolean
  isChrome: boolean
  isFirefox: boolean
  isEdge: boolean
}

export function useDevice(): DeviceInfo {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    isIOS: false,
    isAndroid: false,
    isSafari: false,
    isChrome: false,
    isFirefox: false,
    isEdge: false,
  })

  useEffect(() => {
    const updateDeviceInfo = () => {
      const ua = navigator.userAgent.toLowerCase()
      const width = window.innerWidth

      // Check for mobile devices
      const isMobileDevice =
        /mobile|iphone|ipod|android|blackberry|opera mini|iemobile|wpdesktop/i.test(ua)
      // Check for tablets
      const isTabletDevice = /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/i.test(ua)

      // Check for specific operating systems
      const isIOS = /ipad|iphone|ipod/.test(ua)
      const isAndroid = /android/.test(ua)

      // Check for specific browsers
      const isSafari = /safari/.test(ua) && !/chrome/.test(ua)
      const isChrome = /chrome/.test(ua) && !/edge/.test(ua)
      const isFirefox = /firefox/.test(ua)
      const isEdge = /edge/.test(ua)

      // Determine device type based on screen width and user agent
      const isMobile = width < 768
      const isTablet = width >= 768 && width < 1024
      const isDesktop = width >= 1024

      setDeviceInfo({
        isMobile,
        isTablet,
        isDesktop,
        isIOS,
        isAndroid,
        isSafari,
        isChrome,
        isFirefox,
        isEdge,
      })
    }

    // Initial check
    updateDeviceInfo()

    // Update on window resize
    window.addEventListener('resize', updateDeviceInfo)

    return () => {
      window.removeEventListener('resize', updateDeviceInfo)
    }
  }, [])

  return deviceInfo
}
